'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');
var lodash = require('lodash');

module.exports = assign({}, ServiceClientBase.prototype, {
    getRecentOrders: function getRecentOrders(params) {
        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().orderingRecent, qs, params);
    },

    /**
     * @param params
     * @param {String} params.deviceId
     * @param {String} params.token
     * @param {String} params.siteNum
     * @param {String} params.orderModeId
     * @param {Array}  params.order.lineItems[productId, salesItemId, menuItemId, quantity]
     * @returns {Bluebird Promise}
     */
    getTaxAndTotal: function getTaxAndTotal(params) {
        if (!params) {
            throw Error('missing params');
        }

        var url = getUrlWithGuest(this.getUrl().orderingGetTaxAndTotal, params.isGuest);
        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(url, qs, params);
    },

    /**
     * @param params
     * @param {String} params.deviceId
     * @param {String} params.token
     * @param {String} params.siteNum
     * @param {String} params.orderModeId
     * @param {Object} params.order
     * @param {String} params.order.orderId
     * @param {Object} params.payment
     * @param {String} params.payment.paymentType
     * @param {String=} params.payment.accountNumber (required if ONETIME_CC)
     * @param {String=} params.payment.securityCode (required if ONETIME_CC)
     * @param {String=} params.payment.expirationDate (required if ONETIME_CC)
     * @param {Object=} params.address (required if ONETIME_CC)
     * @param {String} params.address.address1
     * @param {String} params.address.city
     * @param {String} params.address.state
     * @param {String} params.address.postal
     * @param {String} params.address.cntry
     * @returns {Bluebird Promise}
     */
    submit: function submit(params) {
        if (!params) {
            throw Error('missing params');
        }

        var qs = this.pullQueryStringParams(params);

        var url = getUrlWithGuest(this.getUrl().orderingSubmit, params.isGuest);
        return this.postApiRequest(url, qs, params);
    },

    /**
     * checks in an order to the restaurant
     * @param params list of parameters needed for the 
     */
    checkin: function checkin(params) {

        var qs = this.pullQueryStringParams(params);
        //split out params into post data
        var postParams = {
            token: params.token,
            deviceId: params.deviceId,
            siteNum: params.siteNum,
            orderModeId: params.orderModeId,
            order: { orderId: params.orderId }
        };

        var url = getUrlWithGuest(this.getUrl().orderingCheckin, params.isGuest);
        return this.postApiRequest(url, qs, postParams);
    },

    /**
     * checks in a web order to the restaurant
     * @param params list of parameters needed for the
     */
    checkinVerification: function checkinVerification(params) {
        var qs = this.pullQueryStringParams(params);
        var postParams = { verification: params.verification };

        var url = this.getUrl().orderingCheckinVerification;
        return this.postApiRequest(url, qs, postParams);
    },

    cancel: function cancel(params) {
        var qs = this.pullQueryStringParams(params);

        //split out params into post data
        var postParams = {
            token: params.token,
            deviceId: params.deviceId,
            siteNum: params.siteNum,
            order: { orderId: params.orderId }
        };

        var url = getUrlWithGuest(this.getUrl().orderingCancel, params.isGuest);
        return this.postApiRequest(url, qs, postParams);
    },
    submitAndCheckIn: function submitAndCheckIn(params) {
        if (!params) {
            throw Error('missing params');
        }

        var qs = this.pullQueryStringParams(params);

        var url = getUrlWithGuest(this.getUrl().orderingSubmitAndCheckin, params.isGuest);
        return this.postApiRequest(url, qs, params);
    }
});

function getUrlWithGuest(baseUrl, isGuest) {
    if (isGuest) {
        baseUrl += '/guest';
    }

    return baseUrl;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/orderServiceClient.js
// module id = 768
// module chunks = 0